import FingerprintJS, { type GetResult } from '@fingerprintjs/fingerprintjs';
import { cookie, COOKIE_KEY_MAP } from '@shared/services';

const beacon = cookie.get(COOKIE_KEY_MAP.beacon) || '';

function fetchClientFingerprint() {
    const fpPromise = FingerprintJS.load();

    return fpPromise;
}

function setBeaconCookie(resp: GetResult) {
    cookie.set(COOKIE_KEY_MAP.beacon, resp.visitorId, '1y');
}

export function preinit() {
    if (!beacon) {
        fetchClientFingerprint()
            .then((fp) => fp.get())
            .then(setBeaconCookie);
    }
}
